export default "__VITE_ASSET__EBObgTmu__"